/* globals lp, Class, jui, $H, $, $$ */
var jQuery = require('jquery');
var _      = require('lodash');
var Rx     = require('ub_wrapped/rx');

var ubBanzai = require('ub/control/banzai-features');

var endpoints = require('ub/config/endpoints').default;
var ajaxAsObservable = require('ub/control/ajax-as-observable');
var svgUploadHelper = require('ub/ui/svg/svg-upload').default;

lp.editor.AssetUploader = Class.create(jui.Component, {
  options: function($super,options){
    return $super($H({
      attributes:{className:'asset-uploader modal-asset-uploader'}
    }).merge(options));
  },

  initialize: function($super, options){
    this.enabled = true;
    this.buttonEnabled = true;
    this.imageFileExtensions = ['jpg', 'jpeg', 'gif', 'png', 'bmp'];
    if (ubBanzai.features.isSvgUploadEnabled()) {
      this.imageFileExtensions.push('svg');
    }
    this.onlyImages = false;
    $super(options);
  },

  installUI: function($super) {
    $super();
    var self = this;
    var csrf_meta_tag      = $$('meta[name=csrf-token]')[0];
    var authenticity_token = csrf_meta_tag ? csrf_meta_tag.readAttribute('content') : '';
    var assetsPath = endpoints.assetsByCompanyId(window.editor.currentCompanyId);

    this.uploadButton = this.insert( new jui.Button({
        label:'Upload New Images',
        action:this.upload.bind(this),
        classNames:['left js-upload-images-button action upload-images-button modal-button svg-ico-upload']}
    ));
    this.uploadForm = this.insert( new Element('div', {className:'image-upload-form'}).insert(
      '<form action="' + assetsPath + '" class="new_image_asset" enctype="multipart/form-data" id="new_image_asset" method="post" target="image_asset_upload_iframe">'+
      '<input name="authenticity_token" type="hidden" value="' + authenticity_token + '" />'+
      '<input class="hide" id="only_images" name="only_images" type="hidden" value="false" />'+
      '<input class="hide" id="asset_content" name="asset[content]" size="30" type="file" value="Upload File" style="display:none"/>'+
      '</form>'
    ));

    if ($('image_asset_upload_iframe') === null) {
      window.document.body.insert( new Element('iframe', {name:'image_asset_upload_iframe', id:'image_asset_upload_iframe', className:'image_asset_upload_iframe'}));
    }
    var form = this.uploadForm.down('form');

    //If we allow only images than don't even try to upload anything else.
    var $multiMsg = jQuery('<div class="left js-multi-msg hover-msg" ></div>')
      .html('Upload multiple <span class="js-filetype">files</span> at once!');

    this.insert($multiMsg[0]);

    if (! ubBanzai.features.isSandboxEnabled()) {
      jQuery(this.uploadButton.e)
        .hover(
          function(){
            $multiMsg.addClass('show');
          },
          function(){
            $multiMsg.removeClass('show');
          }
        );
    }

    this.fileUploadMulti = new Element(
      'input',
      {
        id: 'asset_multi_upload',
        multiple: 'multiple',
        type: 'file',
        name: 'asset_multi_upload'
      });

    form.insert(this.fileUploadMulti);
    var mkImageAjaxPostObs = function(imageUploadEntry) {
      var data = new FormData();
      data.append('authenticity_token', authenticity_token);
      data.append('only_images', false);
      data.append('update_cache', imageUploadEntry.updateCache);
      data.append('asset[content]', imageUploadEntry.content);
      return ajaxAsObservable({
        type        : 'POST',
        url         : assetsPath,
        contentType : false,
        processData : false,
        data        : data
      })
      .map(function(resp) {
        return parseAssetUploadResponse(resp.data, imageUploadEntry);
      })
      .catch();
    };


    var parseAssetUploadResponse = function(payload, assetEntry) {
      // this is a hack to work around the lack of a json response from lp-webapp.
      // The old implementation loads html with a script tag in it and fires a callback.
      var prefix = 'assetUploaded(';
      var badjson = payload.substring(
        payload.indexOf(prefix)+prefix.length, payload.indexOf('});')+1);
      var goodjson = badjson.replace(/\s*([a-z_]+):/g, '"$1":').replace(/'/g, '"');

      if(goodjson === badjson || ! assetEntry.isValid){
        return { error: assetEntry.content.name };
      } else {
        return { success: JSON.parse(goodjson) };
      }

    };


    var getImageUploadEntries = function(assets) {
      // for multiple image upload batches we we tell the webapp to hold off updating
      // memcache until the final image.
      var imageUploadEntries = _.map(
          assets,
        function(f) {
          return {
            content: f,
            updateCache: false,
            isValid: self._validateFilename(f.name, f.type)
          };
        });

      imageUploadEntries[imageUploadEntries.length-1].updateCache = true;
      return imageUploadEntries;
    };

    var concurrentUploadLimit = 1;

    var handleUploadComplete = function(fn) {
      fn();
      self._hideUploadOverlay();
      self.buttonEnabled = true;
      self.enable();
    };

    var invalidUploadNames = [];
    Rx.Observable.fromEvent(this.fileUploadMulti, 'change')
     .subscribe(function handleMultipleImageUpload() {
          self.buttonEnabled = false;
          self.setControlStates();
          self._showUploadOverlay(self.onlyImages ? 'images' : 'files');
          self.buttonLabel = self.uploadButton.getLabel();
          jQuery('.js-upload-images-button').removeClass('action');
          self.uploadButton.setLabel('Uploading Files...');
          svgUploadHelper.addColorClassesToSvgs(Array.from(self.fileUploadMulti.files))
            .then(function(assets) {
              var allAssets = getImageUploadEntries(assets);
              var uploadEvs = Rx.Observable.fromArray(allAssets)
                .bufferWithCount(concurrentUploadLimit)
                .concatMap(function(setOfFiles) {
                  return Rx.Observable.fromArray(setOfFiles)
                    .concatMap(mkImageAjaxPostObs);
                })
                .subscribe(
                  function onNext(response) {
                    if (response.error) {
                      invalidUploadNames.push(response.error);
                    } else {
                      self.fireEvent('assetUploaded', response.success);
                    }
                  },

                  function onError() {},

                  function onComplete() {
                    handleUploadComplete(function(){

                      //display error message if there are any failures
                      if ( ! _.isEmpty(invalidUploadNames)) {
                        self.assetUploadFailed([invalidUploadNames.join(', ')]);
                        invalidUploadNames = [];
                      }

                      window.localStorage.removeItem("assets" + window.editor.currentCompanyId);
                    });
                  });
              Rx.Observable.fromEvent(jQuery(".js-asset-upload-cancel-btn"), "click")
                .subscribe(function() {
                  uploadEvs.onCompleted();
                });
            });
        });

    this.uploadButton.observe('click', function() {
      self.options.assetChooser.dismissErrorDialog();
    });

    form.setOpacity(0);
  },

  _validateFilename: function(filename, filetype) {
    if ( ! filename) {
      return false;
    }
    var pass = true;
    if(this.onlyImages || filetype.substring(0, 5) === 'image') {
      var fileExtension = filename.split('.').last().toLowerCase();
      //If this is not a file fail the validation.
      if(!this.imageFileExtensions.include(fileExtension)) {
        pass = false;
      }
    }
    return pass;
  },

  enable: function() {
    this.enabled = true;
    this.setControlStates();
  },

  disable: function() {
    this.enabled = false;
    this.setControlStates();
  },

  setEnabled: function(enable) {
    this[enable ? 'enable' : 'disable']();
  },

  cancel: function() {
    //This cancels the actual post in turn stopping the upload from happening.
    $('image_asset_upload_iframe').src = 'about:blank';
    this.enable();
    this.reset();
    this.buttonEnabled = true;
  },

  _showUploadOverlay: function(fileType) {

    this.uploadOverlay = new jui.ModalSheet({attributes: {className: 'modal-sheet loading-overlay uploading-overlay'}});
    this.uploadOverlay.open(this.options.assetChooser);

    this.uploadOverlay.insert(jQuery('<div class="loading-container"><div class="loading-icon"></div>' +
                                     '<div class="loading-title">Uploading ' + fileType + '...</div>'+
                                     '<div class="loading-message">Please wait, this might take a while.</div>'+
                                     '</div>')[0]);

    jQuery('.js-multi-msg').css({'visibility': 'hidden'});
    jQuery('.js-asset-upload-choose-btn').addClass('dsbl');
  },

  _hideUploadOverlay: function() {
    jQuery('.js-multi-msg').css({'visibility':'visible'});
    jQuery('.js-asset-upload-choose-btn').removeClass('dsbl');

    this.uploadOverlay.close();
  },
  setControlStates: function() {
    this.uploadButton.setEnabled(this.buttonEnabled && this.enabled);
  },

  setButtonLabel: function(label) {
    this.buttonLabel = label;
    this.uploadButton.setLabel(this.buttonLabel);
  },

  reset: function() {
    this.uploadForm.down('form').reset();
    this.uploadButton.show();
    this.uploadButton.setLabel(this.buttonLabel);
    this.uploadForm.show();
  },

  upload: function() {
    this.fileUploadMulti.click();
  },

  assetUploaded: function(asset) {
    this.buttonEnabled = true;
    this.setControlStates();
    this.fireEvent('assetUploaded', asset);
  },

  assetUploadFailed: function(errors) {
    var error;

    this.buttonEnabled = true;
    this.setControlStates();

    var messageSuffix = errors.length > 0 ? errors[0] : 'Please try again.';
    error = 'Sorry, there was an error uploading the following: ' + messageSuffix;

    this.uploadButton.setLabel(this.buttonLabel);

    this.fireEvent('assetUploadFailed', error);
  },

  _setAcceptTypeForUpload: function(onlyImages) {
    this.fileUploadMulti.accept = onlyImages ? 'image/*' : '*';
  },
  setOnlyImages: function(bool) {
    this.onlyImages = bool;
    this.uploadForm.down('input#only_images').value = bool;
    this._setAcceptTypeForUpload(bool);
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/asset_uploader.js
// module id = 1008
// module chunks = 0